import React, { useContext, useRef, useState } from "react";
import styled from "@emotion/styled";
import SearchIcon from "./search-icon.svg";
import WhiteSearchIcon from "./search-icon-white.svg";
import CrossIcon from "./cancel-icon-grey.svg";
import LeftArrow from "./left-arrow-white.svg";
import { Link } from "react-router-dom";
import { MovieContext } from "../../Context/MovieContext";
import { FilterContext } from "../../Context/FilterContext";
import { getMovies } from "../../MovieQueries";
export default function Navbar() {
  const [searchState, setSearchState] = useState(false);
  const [hasSearched, sethasSearched] = useState(false);
  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  const mobileinputRef = useRef(null);
  const mobilebuttonRef = useRef(null);
  const { moviesList, setmoviesList } = useContext(MovieContext);
  const { Filters } = useContext(FilterContext);
  const searchHandler = () => {
    if (inputRef.current.value.trim() !== "" && !hasSearched) {
      buttonRef.current.src = CrossIcon;
      getMovies(10, null, moviesList, setmoviesList, [
        `title_contains : "${inputRef.current.value}"`,
      ]);
      sethasSearched(!hasSearched);
    } else if (inputRef.current.value.trim() !== "" && hasSearched) {
      buttonRef.current.src = SearchIcon;
      inputRef.current.value = "";
      getMovies(10, Filters, moviesList, setmoviesList, []);
      sethasSearched(!hasSearched);
    }
  };
  const mobileSearchHandler = () => {
    if (mobileinputRef.current.value.trim() !== "" && !hasSearched) {
      mobilebuttonRef.current.src = CrossIcon;
      getMovies(10, null, moviesList, setmoviesList, [
        `title_contains : "${mobileinputRef.current.value}"`,
      ]);
      sethasSearched(!hasSearched);
    } else {
      mobilebuttonRef.current.src = SearchIcon;
      mobileinputRef.current.value = "";
      getMovies(10, Filters, moviesList, setmoviesList, []);
      sethasSearched(!hasSearched);
    }
  };

  // useEffect(() => {
  //   if (SearchQuery.trim() === "") {
  //     buttonRef.current.disabled = true;
  //   } else {
  //     buttonRef.current.disabled = false;
  //   }
  //   return () => {
  //     setSearchQuery("");
  //   };
  // }, [SearchQuery]);

  return (
    <Container>
      {!searchState && (
        <>
          <Logo>
            <Link to="/" style={{textDecoration : "none",color : "white"}}>DriveFlix</Link>
          </Logo>
          <NavLinks>
            <li>
              <Link to="/">Movies</Link>
            </li>
            {/* <li>
              <a href="/">Web Series</a>
            </li> */}
          </NavLinks>
          <Search>
            <input type="text" placeholder="Search.." ref={inputRef} />
            <SearchButton
              src={SearchIcon}
              onClick={searchHandler}
              ref={buttonRef}
            />
          </Search>
          <SearchButton
            src={WhiteSearchIcon}
            className="mobile-search"
            onClick={() => setSearchState(true)}
          />
        </>
      )}
      {searchState && (
        <>
          <img
            src={LeftArrow}
            alt=""
            height="25px"
            onClick={() => setSearchState(false)}
          />
          <Search visible={true}>
            <input type="text" placeholder="Search.." ref={mobileinputRef} />
            <SearchButton
              src={SearchIcon}
              onClick={mobileSearchHandler}
              ref={mobilebuttonRef}
            />
          </Search>
        </>
      )}
    </Container>
  );
}

const Container = styled.div`
  max-width: 100vw;
  color: white;
  display: flex;
  background: #1d0b5c;
  padding: 10px 130px;
  align-items: center;
  flex: 0.01;
  @media (max-width: 877px) {
    padding: 10px 20px;
    justify-content: center;
  }

  .mobile-search {
    @media (min-width: 769px) {
      display: none;
    }
  }
`;

const Logo = styled.div`
  font-size: 170% !important;
  font-weight: 800 !important;
  color : white;
  @media (max-width: 768px) {
    font-size: 103% !important;
  }
`;

const NavLinks = styled.ul`
  list-style: none;
  flex: 1;
  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
  }
  & > li {
    display: inline-block;
    margin-left: 10px;
    margin-right: 10px;
    @media (max-width: 768px) {
      margin-right: 0px;
      margin-left: 15px;
      font-size: 90%;
    }
    & > a {
      color: white;
      text-decoration: none;
    }
  }
`;

const Search = styled.div`
  background: white;
  padding: 10px 20px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    display: ${(props) => (props.visible ? "flex" : "none")};
    width: 100%;
    padding: 7px 10px;
    margin: 8px 0px;
    margin-left: 10px;
  }
  & > input {
    background: transparent;
    border: none;
    color: grey;
    font-size: 97%;
    width: 100%;
    @media (max-width: 768px) {
      font-size: 90%;
    }
  }
`;

const SearchButton = styled.img`
  max-height: 20px;
  cursor: pointer;
`;
